/** Unwrap { success, data } API responses; pass through legacy shapes. */
export function unwrapData(body) {
  if (body == null) return body;
  if (typeof body === 'object' && body.success === true && body.data !== undefined) {
    return body.data;
  }
  return body;
}
